import { useState, useEffect } from 'react';
import { sectionsRefer } from '@/enums/sectionsRefer';

export default function useHeaderChangeTheme() {
  const [headerTheme, setHeaderTheme] = useState<string>('default');
  const [logoColor, setLogoColor] = useState<string>('black');

  useEffect(() => {
    function setupIntersectionObserver() {
      const homeProviderSection = document.getElementById(
        sectionsRefer.providers,
      );

      if (!homeProviderSection) return;

      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              setHeaderTheme('dark');
              setLogoColor('white');
            } else {
              setHeaderTheme('light');
              setLogoColor('black');
            }
          });
        },
        {
          rootMargin: '-1px 0px',
          threshold: 0.1,
        },
      );

      observer.observe(homeProviderSection);

      // Cleanup ao desmontar o componente
      return () => {
        observer.disconnect();
      };
    }

    const timer = setTimeout(() => {
      setupIntersectionObserver();
    }, 100);

    return () => clearTimeout(timer);
  }, [headerTheme, logoColor]);

  return {
    headerTheme,
    logoColor,
  };
}
